function formatDate(dateStr) {
  if (dateStr.length === 8) {
    const year = dateStr.substring(0, 4)
    const month = dateStr.substring(4, 6)
    const day = dateStr.substring(6, 8)
    return `${year}-${month}-${day}`
  }
  return dateStr
}

export default {
  mounted(el) {
    const input = el.querySelector('input')
    if (input) {
      let cachedDigits = ''
      let formatting = false

      // 每次输入时缓存纯数字，不做格式化
      input.addEventListener('input', (event) => {
        if (formatting) return
        cachedDigits = event.target.value.replace(/-/g, '')
      })

      // blur 或 change 时用缓存值格式化写入
      const handleFormat = (event) => {
        if (!cachedDigits || cachedDigits.length !== 8 || isNaN(cachedDigits)) {
          return
        }
        const formatted = formatDate(cachedDigits)
        formatting = true
        event.target.value = formatted
        cachedDigits = ''
        // 分发事件触发 el-date-picker 校验
        const inputEvent = new Event('input', { bubbles: true })
        event.target.dispatchEvent(inputEvent)
        const changeEvent = new Event('change', { bubbles: true })
        event.target.dispatchEvent(changeEvent)
        formatting = false
      }
      input.addEventListener('change', handleFormat)
      input.addEventListener('blur', handleFormat)

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          input.blur()
        }
      })
    }
  },
}
